function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#de6d26;}.cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "MSD for website");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("polygon", {
  className: "cls-1",
  points: "576.23 224.88 611.03 224.88 473.44 5.71 450.53 5.71 313.08 224.88 347.86 224.88 461.99 43.83 576.23 224.88"
}), React.createElement("polygon", {
  className: "cls-2",
  points: "146.91 186.63 30.79 6.03 0 6.03 0 224.88 30.21 224.88 30.21 61.15 135.7 224.88 158.59 224.88 263.93 61.85 263.93 224.88 293.82 224.88 293.82 6.03 263.19 6.03 146.91 186.63"
}), React.createElement("path", {
  className: "cls-2",
  d: "M858.56,63.25c-6.46-14.09-15.57-25.61-27-34.1-11.29-8.41-24.84-14.48-40.1-18A218.22,218.22,0,0,0,742.79,6H630.29V224.88H743a240,240,0,0,0,33.32-2.26,144,144,0,0,0,29.82-7.32,101.46,101.46,0,0,0,25.46-13.62,81.6,81.6,0,0,0,19.69-21,97.9,97.9,0,0,0,12.46-28.65,143.69,143.69,0,0,0,4.36-36.9C868.22,94.7,865,77.19,858.56,63.25Zm-21,52.08c0,16-2.33,29.43-6.93,39.79-4.51,10.2-10.82,18.37-18.84,24.37s-18.06,10.43-29.5,12.92a187.43,187.43,0,0,1-39.48,3.89H660.5V34.52h82.29A215.29,215.29,0,0,1,770,36.16a113.27,113.27,0,0,1,23.13,5.37,74.58,74.58,0,0,1,18.68,9.73,54.27,54.27,0,0,1,13.7,14.56,69,69,0,0,1,8.8,20.94A116.61,116.61,0,0,1,837.54,115.33Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M869.82,22.76C869.82,9.24,879.64,0,891.66,0s21.72,9.24,21.72,22.76-9.82,22.77-21.72,22.77S869.82,36.28,869.82,22.76Zm38.94,0c0-10.86-7.39-18.6-17.1-18.6s-17.22,7.74-17.22,18.6S882,41.25,891.66,41.25,908.76,33.74,908.76,22.76Zm-25.54-12H892c4.85,0,9.12,2,9.12,7.51a6.74,6.74,0,0,1-4.39,6.35l5.32,9.59h-5.32l-4-8.09H888V34.2h-4.74ZM891,22.42c3.12,0,5-1.39,5-3.93,0-2.2-1.27-3.82-4.73-3.82H888v7.75Z"
})));

var SvgMsdLogo = function SvgMsdLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 913.38 224.88",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMsdLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/msd-logo.8f9d3810.svg";
export { ForwardRef as ReactComponent };